import languageTypes from "./language.types"

const setLanguage=(lang)=>({
    type:languageTypes.SET_LANGUAGE,
    payload:lang
})

export default setLanguage